import React, { useState } from 'react'
import PropTypes from 'prop-types'

const PriceContext = React.createContext({})
PriceContext.displayName = 'PriceContext'
export default PriceContext

const PriceStore = ({ children }) => {
  const [get, set] = useState(0)
  return (
    <PriceContext.Provider value={{ get, set }}>
      {children}
    </PriceContext.Provider>
  )
}
PriceStore.propTypes = { children: PropTypes.node.isRequired }
export { PriceStore }
